import {
  buildHasuraQuery,
  ConfigurationType as MuiAdminConfigurationType,
  DefaultConfiguration as MuiFormDefaultConfiguration,
  HasuraQuery,
} from '@kirz/mui-admin';

import { api } from 'services/api';

export const Configuration = {
  muiAdmin: {
    ...MuiFormDefaultConfiguration,
    translations: {
      valueRequired: 'Требуется значение',
      wrongEmailFormat: 'Неверный формат',
      wrongPhoneFormat: 'Неверный формат',
      wrongDateFormat: 'Неверный формат',
      autocompletePlaceholder: 'Введите и нажмите «Enter»',
      tableSearchPlaceholder: 'Поиск по названию',
      tableAddFilterTooltip: 'Добавить фильтр',
      tableNoRows: 'Нет данных',
      unexpectedError: 'Произошла ошибка',
      deleteTableRow: 'Удалить',
      attachmentsZoneTitle: 'Выберите тип вложения',
      attachmentsZoneLabel: 'Тип вложения',
      attachmentsZoneAccept: 'Загрузить',
      attachmentsZoneCancel: 'Отмена',
      attachmentsUploadedSuccessfully: 'Файлы загружены',
      attachmentsUploadedOrDropFileHere: 'Перетащите или выберите файл',
      attachmentsNoFiles: 'Нет загруженных файлов',
      attachmentsFileMenuDownload: 'Скачать',
      attachmentsFileMenuDelete: 'Удалить',
      addNewAutocompleteValue: 'Добавить',
      attachmentsFileMenuMove: 'Переместить',
      attachmentsFileMenuRename: 'Переименовать',
      attachmentsZoneFileRenameTitle: 'Переименовать файл',
      attachmentsZoneFileRenameText: 'Введите новое имя',
      attachmentsZoneFileRenameLabel: 'Имя файла',
      exportCsv: 'Экспорт в CSV',
      cancel: 'Отмена',
      addNew: 'Добавить',
      copied: 'Скопировано',
      create: 'Создать',
      open: 'Открыть',
      save: 'Сохранить',
      saved: 'Сохранено',
      saveAndExit: 'Сохранить и выйти',
      nullSelectOptionText: 'None',
      changesNotSaved: 'Изменения не сохранены!',
      youWillLoseAllUnsavedData:
        'При выходе вы потеряете все несохраненные данные.',
      goAnyways: 'Перейти',
      clear: 'Очистить',
      noFile: 'Отсутствует',
      notSet: 'Отсутствует',
      columnFillAvailableSpace: 'Заполнить свободное пространство',
      resetTableState: 'Сбросить к значениям по умолчанию',
    },
    defaultPhoneCountry: 'RU',
    defaultLocale: 'ru',
    availableLocales: ['en', 'ru'],
    defaultDeleteConfirm: {
      ...MuiFormDefaultConfiguration.defaultDeleteConfirm,
      title: 'Удалить выбранный элемент?',
      accept: 'Удалить',
      cancel: 'Отмена',
    },
    defaultDeleteFileConfirm: {
      ...MuiFormDefaultConfiguration.defaultDeleteFileConfirm,
      title: 'Удалить файл?',
      accept: 'Удалить',
      cancel: 'Отмена',
    },
    hasura: {
      ...MuiFormDefaultConfiguration.hasura,
      subscribe(request: HasuraQuery, onNext: (value: any) => void) {
        const { extractResult, query, variables } = buildHasuraQuery(request);

        const onNextResponse = ({ data }: any) => {
          onNext(
            typeof extractResult === 'function' ? extractResult(data) : data,
          );
        };

        const unsubscribe = api.hasuraWsClientInstance!.subscribe(
          {
            query,
            variables,
          },
          {
            next: onNextResponse,
            error: () => {},
            complete: () => {},
          },
        );

        return unsubscribe;
      },
      primaryKey: 'id',
    },
    rest: {
      ...MuiFormDefaultConfiguration.rest,
      client: api.instance,
    },
    alerts: {
      ...MuiFormDefaultConfiguration.alerts,
      snackbars: {
        ...MuiFormDefaultConfiguration.alerts.snackbars,
        entityCreated: { text: 'Сохранено', variant: 'success' },
        entityUpdated: { text: 'Сохранено', variant: 'success' },
        entityDeleted: { text: 'Удалено', variant: 'success' },
      },
    },
  } as MuiAdminConfigurationType,
};
